import React from 'react';

interface SummaryCardProps {
  title: string;
  value: number | string;
  style?: React.CSSProperties,
}

const SummaryCard: React.FC<SummaryCardProps> = ({ title, value, style }) => {
  return (
    <div className="summary-card-v2" style={style}>
      <h4>{value}</h4>
      <p>{title}</p>
    </div>
  );
};

export default SummaryCard;

